// wrapAround: false,
// adaptiveHeight: true,

import { qs, listen, remove } from "@fluorescent/dom";

const selectors = {
  slider: "[data-slider]",
  prev: "[data-prev]",
  next: "[data-next]",
};

export default node => {
  const sliderElement = qs(selectors.slider, node);
  const previousButton = qs(selectors.prev, node);
  const nextButton = qs(selectors.next, node);
  let slider = null;
  const events = [];

  const config = {
    adaptiveHeight: true,
    cellAlign: "left",
    cellSelector: "[data-slide]",
    pageDots: false,
    prevNextButtons: false,
    contain: true,
    watchCSS: true,
    imagesLoaded: true,
    initialIndex: ".is-initial-select",
    pauseAutoPlayOnHover: !window.Shopify.designMode,
    on: {
      ready: function () {
        this.resize();
        // Need to wait for the flicktiy view-port transiton
        setTimeout(() => {
          _updateNavigationPosition(qs(".media, .placeholder-image", node));
        }, 350);
      },
      scroll: function () {
        _updateNavigationPosition(this.element);
      },
    },
  };

  previousButton.disabled = true;

  const _updateNavigationPosition = image => {
    const currentImageHeight = image.clientHeight;
    const buttonHeight = nextButton.clientHeight;
    const halfcurrentImageHeight = currentImageHeight / 2;
    const halfButtonHeight = buttonHeight / 2;

    const offset = halfcurrentImageHeight - halfButtonHeight;

    node.style.setProperty("--navigation-offset", `${offset}px`);

    remove(nextButton, "hidden");
    remove(previousButton, "hidden");
  };

  import(flu.chunks.flickity).then(({ Flickity }) => {
    slider = new Flickity(sliderElement, config);

    slider.on("scroll", progress => {
      const progressScale = progress * 100;

      // https://github.com/metafizzy/flickity/issues/289
      previousButton.disabled = progressScale < 1;
      nextButton.disabled = progressScale > 99;
    });
  });

  let prevClick;
  let nextClick;
  let prevMouseenter;
  let nextMouseenter;

  import(flu.chunks.gsap).then(({ gsap, CustomEase }) => {
    gsap.registerPlugin(CustomEase);
    prevClick = listen(previousButton, "click", handleClick);
    nextClick = listen(nextButton, "click", handleClick);
    prevMouseenter = listen(previousButton, "mouseenter", arrowMouseenter);
    nextMouseenter = listen(nextButton, "mouseenter", arrowMouseenter);

    const arrowClickEase = gsap.parseEase(window.theme.animation.ease);
    const arrowHoverEase = gsap.parseEase(window.theme.animation.ease);

    function handleClick(evt) {
      const prev = evt.target.closest(selectors.prev);
      const next = evt.target.closest(selectors.next);

      if (prev) {
        slider && slider.previous();
        arrowClick(prev);
      }
      if (next) {
        slider && slider.next();
        arrowClick(next);
      }
    }

    function arrowClick(button) {
      gsap.to(button, {
        keyframes: [{ scale: 0.8 }, { scale: 1 }],
        duration: 0.33,
        ease: arrowClickEase,
      });
    }

    function arrowMouseenter(evt) {
      const svg = qs("svg", evt.target);
      gsap.to(svg, {
        keyframes: [
          { x: 15, opacity: 0 },
          { x: -15, duration: 0 },
          { x: 0, opacity: 1 },
        ],
        duration: 0.43,
        ease: arrowHoverEase,
      });
    }
  });

  return {
    destroy: () => {
      if ((slider.slides || {}).length > 1) {
        prevClick && prevClick();
        nextClick && nextClick();
        prevMouseenter && prevMouseenter();
        nextMouseenter && nextMouseenter();
      }
      slider && slider.destroy();
      events.forEach(unsubscribe => unsubscribe());
    },
    select: index => {
      slider?.select(index);
    },
  };
};
